import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import ServiceAreas from './pages/ServiceAreas';
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import SmsPolicy from './pages/SmsPolicy';
import OptOut from './pages/OptOut';
import ComplianceCenter from './pages/ComplianceCenter';
import BusinessVerification from './pages/BusinessVerification';
import Accessibility from './pages/Accessibility';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
	return (
		<HelmetProvider>
			<Router>
				<div className="App">
					<a href="#main" className="skip-link">Skip to main content</a>
					<ScrollToTop />
					<Header />
					<main id="main" className="main-container">
						<Routes>
							<Route path="/" element={<Home />} />
							<Route path="/services" element={<Services />} />
							<Route path="/about" element={<About />} />
							<Route path="/contact" element={<Contact />} />
							<Route path="/gallery" element={<Gallery />} />
							<Route path="/service-areas" element={<ServiceAreas />} />
							<Route path="/faq" element={<FAQ />} />
							<Route path="/privacy" element={<PrivacyPolicy />} />
							<Route path="/terms" element={<Terms />} />
							<Route path="/sms-policy" element={<SmsPolicy />} />
							<Route path="/opt-out" element={<OptOut />} />
							<Route path="/compliance" element={<ComplianceCenter />} />
							<Route path="/business-verification" element={<BusinessVerification />} />
							<Route path="/accessibility" element={<Accessibility />} />
							<Route path="*" element={<NotFound />} />
						</Routes>
					</main>
					<Footer />
					<CookieConsent />
				</div>
			</Router>
		</HelmetProvider>
	);
}

export default App;
